import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3257153e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3257153e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3257153e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3257153e')) {
      api.createRecord('3257153e', component.options)
    } else {
      api.reload('3257153e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3257153e&scoped=true&", function () {
      api.rerender('3257153e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/svg-sprite/index.vue"
export default component.exports